import { render, staticRenderFns } from "./ButtonPill.vue?vue&type=template&id=39738f33"
import script from "./ButtonPill.vue?vue&type=script&lang=js"
export * from "./ButtonPill.vue?vue&type=script&lang=js"
import style0 from "./ButtonPill.vue?vue&type=style&index=0&id=39738f33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports